<div [ngStyle]="getStyles()" class="skeleton loader" ></div>